// Preferences that belong to THIS PHONE, not to the kit.
//
// The kit is data about a gym — its bar, its collars, its plates — and it may
// one day be shared between phones. Whether the drawing animates is about the
// person holding this one, so it lives beside Sound and Haptics: in `prefs`
// (core/storage.js, a Proxy over localStorage), under the same `pref.` names
// SettingsModal uses. Default ON: an unset preference reads `!== false`.
//
// Read reactively: pages hand `loadingMotion` to BarSleeve's `animate`, so
// flipping the switch in Kit changes the Bar tab that is still mounted behind it.
import { computed, ref } from 'vue'
import { prefs } from '../core/storage.js'

const KEY = 'pref.animateLoading'

/** The Kit switch: animate plates going on and off the bar. */
export const animateLoading = ref(prefs[KEY] !== false)

export function setAnimateLoading(on) {
  animateLoading.value = !!on
  prefs[KEY] = !!on
}

// REDUCE MOTION ALWAYS WINS. The OS setting is a person telling every app on
// the phone to stop moving things about; an in-app switch set to On does not
// overrule it. Tracked live, because it can change while the app is open.
const query = typeof matchMedia === 'function' ? matchMedia('(prefers-reduced-motion: reduce)') : null
export const reducedMotion = ref(!!query?.matches)
query?.addEventListener?.('change', (e) => { reducedMotion.value = e.matches })

/** What a page passes to BarSleeve's `animate`. */
export const loadingMotion = computed(() => animateLoading.value && !reducedMotion.value)
